module.exports = __webpack_public_path__ + "static/media/184.ba153a10.mp3";